export function calculateExpirationTime({ expiresIn }: { expiresIn: number }) {
	return expiresIn * 1000 + Date.now()
}
